import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <div className="py-10 md:py-14 border-y border-white/10 bg-[#050505] overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {t.marquee.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-medium text-5xl md:text-7xl lg:text-8xl text-outline whitespace-nowrap px-8 md:px-14">
              {item}
            </span>
            <span className="w-3 h-3 md:w-4 md:h-4 bg-[#FF7900] rotate-45" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
